/**
 * @generated SignedSource<<aae968c840526789eb61ee4cc367ca20>>
 * @relayHash 345c5f1988f7cdd53e817c3bdf9cb42d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 58029921125cbf0223c7eb0f71f30fc5b540109c77368cffff68701920a79388

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AggTeamDirectoryPageQuery$variables = {
  enablePagination?: boolean | null;
  scopeId: string;
  teamExistenceQuery?: string | null;
};
export type AggTeamDirectoryPageQuery$data = {
  readonly team: {
    readonly hasTeams: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "TeamConnectionEdge";
      }> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"teamCustomFieldResolverFields">;
  } | null;
};
export type AggTeamDirectoryPageQuery = {
  response: AggTeamDirectoryPageQuery$data;
  variables: AggTeamDirectoryPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enablePagination"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scopeId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamExistenceQuery"
},
v3 = {
  "kind": "Variable",
  "name": "scopeId",
  "variableName": "scopeId"
},
v4 = {
  "args": [
    (v3/*: any*/)
  ],
  "concreteType": "TeamCustomFieldInfo",
  "kind": "LinkedField",
  "name": "customFieldsWithinScope",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    }
  ]
},
v5 = {
  "alias": "hasTeams",
  "args": [
    {
      "kind": "Variable",
      "name": "enablePagination",
      "variableName": "enablePagination"
    },
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    },
    {
      "kind": "Variable",
      "name": "q",
      "variableName": "teamExistenceQuery"
    },
    (v3/*: any*/)
  ],
  "concreteType": "TeamConnection",
  "kind": "LinkedField",
  "name": "teamsTql",
  "plural": false,
  "selections": [
    {
      "concreteType": "TeamConnectionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AggTeamDirectoryPageQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "teamCustomFieldResolverFields",
            "selections": [
              (v4/*: any*/)
            ],
            "argumentDefinitions": [
              {
                "kind": "RootArgument",
                "name": "scopeId"
              }
            ]
          },
          (v5/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AggTeamDirectoryPageQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "58029921125cbf0223c7eb0f71f30fc5b540109c77368cffff68701920a79388",
    "metadata": {},
    "name": "AggTeamDirectoryPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bc80a325200507976b05a5b196af1f68";

export default node;
